import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ScheduleListComponent } from './schedule-list.component';
import { ScheduleTimeModule } from '@finder/shared/components/schedule-time/schedule-time.module';

@NgModule({
    imports: [
        CommonModule,
        ScheduleTimeModule,
    ],
    declarations: [
        ScheduleListComponent,
    ],
    providers: [],
    exports: [
        ScheduleListComponent,
    ]
})
export class ScheduleListModule {}

